








































































import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import FaqForm from '@/shared/src/views/Faq/FaqForm.vue';
import { Component, Vue } from 'vue-property-decorator';
import { email } from 'vee-validate/dist/rules';
import { SupportService } from '@/parents-portal/src/services';

extend('email', {
  ...email,
  message: '{_field_} is not valid',
});

@Component({
  components: {
    FaqForm,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class Top extends Vue {
  private service = new SupportService();
}
